import React from 'react';
import { Grid, Container, Divider } from 'semantic-ui-react';
import LocalImage1 from '@/assets/images/carousel/carousel-image-1.png';
import LocalImage2 from '@/assets/images/carousel/carousel-image-2.png';
import LocalImage3 from '@/assets/images/carousel/carousel-image-3.png';
import LocalImage4 from '@/assets/images/carousel/carousel-image-4.png';
import LocalImage5 from '@/assets/images/carousel/carousel-image-5.png';
import HomeBanner from './HomeBanner';
import HomePanelLaunchers from './HomePanelLaunchers';
import HomePanelCustomContent from './HomePanelCustomContent';
import HomeFooterLogo from './HomeFooterLogo';
import HomePanelCarousel from './HomePanelCarousel';

const HomePanelFull = () => (
  <div className="aridhia-home-panel-full">
    <HomeBanner />
    <Container className="aridhia-home-header">
      <Grid columns="equal" stackable>
        <HomePanelLaunchers />
        <Divider horizontal className="border-t w-100" />
        <Grid.Row>
          <HomePanelCustomContent />
          <HomePanelCarousel codes={[
            { code: 'carousel-image-1.png', local: LocalImage1 },
            { code: 'carousel-image-2.png', local: LocalImage2 },
            { code: 'carousel-image-3.png', local: LocalImage3 },
            { code: 'carousel-image-4.png', local: LocalImage4 },
            { code: 'carousel-image-5.png', local: LocalImage5 },
          ]}
          />
        </Grid.Row>
        <Divider horizontal className="border-t w-100" />
      </Grid>
      <HomeFooterLogo />
    </Container>
  </div>
);

export default HomePanelFull;
